import LockedInfo from './LockedInfo.vue'

export default LockedInfo
